import styled from '@emotion/styled';
import AddIcon from '@mui/icons-material/Add';
import { ListItem, ListItemText, ListItemIcon, Box } from '@mui/material';
import { FC } from 'react';
import { WsColors, Item, WsTypography, WsTypoColors, WsTypoVariants } from 'wisestep-base';

import ArtificialIntelligence from '../../../../images/ArtificialIntelligence.svg';
const StyledListItem = styled(ListItem)({
  backgroundColor: WsColors.White,
  borderRadius: 3,
  border: '1px solid' + WsColors.TheBlues200,
  cursor: 'pointer',
  padding: 12,
});
const StyleItem = styled(Item)(({ theme }) => ({
  padding: theme.spacing(1),
}));
export interface CandidatesPlaceholderProps {
  onClickPlaceholder(placeholder: string): void;
  isSubmissionEmail?: boolean;
}
const CandidatePlaceholder: FC<CandidatesPlaceholderProps> = ({
  onClickPlaceholder,
  isSubmissionEmail = false,
}) => {
  const submissionEmailData = [
    { key: 'Candidate CV', value: '{{candidateCv}}' },
    { key: 'RTR', value: '{{rtr}}' },
    { key: 'Generate Summary', value: '{{candidateSummary}}' },
    { key: 'Other Fields', value: '{{candidate.otherFields}}' },
  ];
  const candidateData = [
    { key: 'Name', value: '{{candidate.name}}' },
    { key: 'Email', value: '{{candidate.email}}' },
    { key: 'Alternate Emails', value: '{{candidate.alternateEmails}}' },
    { key: 'Phone', value: '{{candidate.phoneNumber}}' },
    { key: 'Alternate PhoneNumbers', value: '{{candidate.alternatePhoneNumbers}}' },
    { key: 'Cv Source', value: '{{candidate.source}}' },
    {
      key: 'Current Location',
      value:
        '{{candidate.currentLocation.city}}, {{candidate.currentLocation.state}}, {{candidate.currentLocation.country}}',
    },
    { key: 'Total Exp in Years', value: '{{candidate.totalYearsExperience}}' },
    { key: 'Relevant Exp in Years', value: '{{candidate.relevantYearsExperience}}' },
    { key: 'Prev Job Title', value: '{{candidate.previousJobTitles}}' },
    { key: 'Prev Employer', value: '{{candidate.previousEmployers}}' },
    { key: 'Current Job Title', value: '{{candidate.currentJobTitle}}' },
    { key: 'Current Job Type', value: '{{candidate.currentJobType}}' },
    {
      key: 'Expected Salary',
      value:
        '{{candidate.expectedSalaryCurrency}} {{candidate.expectedBaseSalary}} {{candidate.expectedBaseSalaryTimeSpan | splitByUpperCase}}',
    },
    {
      key: 'Expected Job Type',
      value: '{{candidate.jobPreferencePermanent}}{{candidate.jobPreferenceContract}}',
    },
    {
      key: 'Current Salary',
      value:
        '{{candidate.currentSalaryCurrency}} {{candidate.currentSalary}} {{candidate.currentSalaryTimeSpan | splitByUpperCase}}',
    },
    { key: 'Notice Period', value: "{{candidate.noticePeriod | stringReplace: '_':' '}}" },
    { key: 'Current Employer', value: '{{candidate.currentEmployer}}' },
    { key: 'Current Allowances and Benefits', value: '{{candidate.otherCurrentAllowances}}' },
    { key: 'Expected Allowances and Benefits', value: '{{candidate.otherExpectedAllowances}}' },
    { key: 'Reason for New Job', value: '{{candidate.reasonForNewJob}}' },
    { key: 'Willing to Relocate', value: '{{candidate.relocationPreference | splitByUpperCase}}' },
    {
      key: 'Willing to Travel',
      value:
        "{{candidate.willingToTravel == null ? 'N/A' : (candidate.willingToTravel ? 'Yes' : 'No')}}",
    },
    { key: 'Visa Status', value: '{{candidate.visaStatus}}' },
    { key: 'Visa Validity', value: '{{candidate.visaValidity}}' },
    { key: 'Family Willing to Relocate', value: '{{candidate.familyWillingToRelocate}}' },
    { key: 'Interviewing with Others?', value: '{{candidate.interviewingWithOthers}}' },
    { key: 'Messenger(example: SkypeId)', value: '{{candidate.messengers}}' },
    { key: 'Skills', value: '{{candidate.skills}}' },
    { key: 'Recruiters Assessment', value: '{{candidate.assessment}}' },
    { key: 'Work Authorization', value: '{{candidate.workAuthorization}}' },
    { key: 'LinkedIn URL', value: '{{candidate.linkedInURL}}' },
    { key: 'Education', value: '{{candidate.higherEducation}}' },
    { key: 'Reason For New Job', value: '{{candidate.reasonForNewJob}}' },
    { key: 'Workspace Name', value: '{{candidate.workspaceName}}' },
    { key: 'Submitted Date', value: '{{candidate.createdOn}}' },
    { key: 'Updated Date', value: '{{candidate.modifiedOn}}' },
    { key: 'Submitted Recruiter Email', value: '{{candidate.createdBy}}' },
    { key: 'Skill Matrix Ratings', value: '{{candidate.skillMatrixRatings}}' },
    { key: 'PortalId', value: '{{candidate.portalId}}' },
    { key: 'ExEmployee Of Client', value: '{{candidate.exEmployeeOfClient}}' },
    { key: 'ExEmployeeId', value: '{{candidate.exEmployeeId}}' },
    { key: 'Work Authorization Validity', value: '{{candidate.workAuthValidity}}' },
    { key: 'Candidate Languages', value: '{{candidate.candidateLanguages}}' },
    { key: 'Nationality', value: '{{candidate.nationality}}' },
    { key: 'SsnNumber', value: '{{candidate.ssnNumber}}' },
    { key: 'Postal Address', value: '{{candidate.postalAddress}}' },
    { key: 'Other Documents', value: '{{candidate.otherDocuments}}' },
    {
      key: 'Client Bill Rate',
      value:
        '{{candidate.clientBillRateCurrency}} {{candidate.clientBillRate}} {{candidate.clientBillRateTimeSpan}}',
    },
    ...(isSubmissionEmail ? submissionEmailData : []),
  ];

  const handleListItemClick = (placeholder: string) => onClickPlaceholder(placeholder);
  return (
    <Box>
      {candidateData.map(({ key, value }) => (
        <StyleItem key={key}>
          <StyledListItem onClick={() => handleListItemClick(value)}>
            {key === 'Generate Summary' && (
              <Box
                component="img"
                src={ArtificialIntelligence}
                alt="ArtificialIntelligence Logo"
                sx={{
                  width: 30,
                  height: 30,
                  objectFit: 'cover',
                  mr: 1,
                }}
              />
            )}
            <ListItemText primary={key} />
            <ListItemIcon>
              <AddIcon />
              <WsTypography color={WsTypoColors.PRIMARY} variant={WsTypoVariants.BODY1}>
                Add
              </WsTypography>
            </ListItemIcon>
          </StyledListItem>
        </StyleItem>
      ))}
    </Box>
  );
};
export default CandidatePlaceholder;
